import axios from 'axios'
import { CRM_API_URL } from '@/constants/api'

function fetchUnconnectedOrganizations () {
    return axios.get(`${CRM_API_URL}/user/organizations/unconnected`).then(response => response.data)
}

function fetchConnectionAgreement (organizationId) {
  return axios.get(`${CRM_API_URL}/user/organizations/${organizationId}/connection-agreement`)
    .then(response => response.data)
}

function acceptConnectionAgreement (organizationId) {
    return axios.patch(`${CRM_API_URL}/user/organizations/${organizationId}/connection-agreement/accept`)
      .then(response => response.data)
}

export default {
  fetchUnconnectedOrganizations,
  fetchConnectionAgreement,
  acceptConnectionAgreement,
}
